// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__QgSxR","footer":"ModalInfo_footer__rQPR1"};